// True when the app is being served from the TOSP custom domain
// (e.g. app.mytosp.com). The AskSmart, CaddieGames, IQVerity, and TOSP front
// ends are the same Static Web App bundle on several domains; this lets the
// shared root route pick the TOSP login/auth experience by hostname. Matches the
// apex and any subdomain so an accidental www/apex hit still routes correctly.
// Returns false for localhost / asksmart.ai so those keep the AskSmart
// experience — including the TOSP module's own /tosp route, which regular
// AskSmart orgs use and which must NOT switch them into the TOSP brand.
//
// The domain is myTOSP's — "mytosp.com", not "tosp.com". Anchored on the dot so
// a lookalike ("notmytosp.com") can never satisfy the suffix test.
export function isTospHost(hostname?: string): boolean {
  const raw = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);
  const host = raw.toLowerCase();
  return host === "mytosp.com" || host.endsWith(".mytosp.com");
}
